import { render, staticRenderFns } from "./RecipientPicker.vue?vue&type=template&id=4fdfa458&scoped=true&"
import script from "./RecipientPicker.vue?vue&type=script&lang=js&"
export * from "./RecipientPicker.vue?vue&type=script&lang=js&"
import style0 from "./RecipientPicker.vue?vue&type=style&index=0&id=4fdfa458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdfa458",
  null
  
)

export default component.exports